import { createAsyncThunk } from '@reduxjs/toolkit'
import * as api from './api'
import { CHANGES, ADD_CHANGE, DELETE_CHANGE } from './types'

export const fetchAllChanges = createAsyncThunk(CHANGES, api.fetchAllChanges)
export const addChange = createAsyncThunk(ADD_CHANGE, api.addChange)
export const deleteChange = createAsyncThunk(DELETE_CHANGE, api.deleteChange)
